"use client";

import Link from "next/link";
import { BLOG_POSTS } from "./posts";

const CATEGORY_COLORS: Record<string, string> = {
  "AI Marketing": "bg-violet-100 text-violet-700",
  Automation: "bg-blue-100 text-blue-700",
  Tools: "bg-emerald-100 text-emerald-700",
  Strategy: "bg-amber-100 text-amber-700",
  Analytics: "bg-rose-100 text-rose-700",
};

export default function BlogPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Nav */}
      <nav className="border-b bg-white/80 backdrop-blur-xl sticky top-0 z-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
          <Link href="/home" className="flex items-center gap-2">
            <div className="h-9 w-9 rounded-lg bg-indigo-600 text-white flex items-center justify-center font-bold text-sm">
              8F
            </div>
            <span className="text-lg font-bold text-slate-900">8thFloor</span>
          </Link>
          <div className="flex items-center gap-3">
            <Link href="/demo" className="text-sm text-slate-600 hover:text-slate-900 font-medium">
              Demo
            </Link>
            <Link href="/docs" className="text-sm text-slate-600 hover:text-slate-900 font-medium">
              Docs
            </Link>
            <Link href="/login" className="text-sm text-slate-600 hover:text-slate-900 font-medium">
              Log In
            </Link>
            <Link
              href="/register"
              className="text-sm bg-indigo-600 text-white px-4 py-2 rounded-lg font-semibold hover:bg-indigo-700 transition"
            >
              Sign Up Free
            </Link>
          </div>
        </div>
      </nav>

      <div className="max-w-5xl mx-auto px-4 py-16 sm:py-20">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl sm:text-5xl font-extrabold text-slate-900 tracking-tight mb-4">
            8thFloor Blog
          </h1>
          <p className="text-lg text-slate-600 max-w-xl mx-auto">
            Tips, guides, and insights on AI-powered marketing for startups and small businesses.
          </p>
        </div>

        {/* Posts Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {BLOG_POSTS.map((post) => (
            <Link
              key={post.slug}
              href={`/blog/${post.slug}`}
              className="group rounded-xl border border-slate-200 bg-white hover:shadow-lg transition-shadow duration-300 overflow-hidden flex flex-col"
            >
              {/* Placeholder Image */}
              <div className="h-40 bg-gradient-to-br from-indigo-50 to-violet-50 flex items-center justify-center">
                <div className="h-12 w-12 rounded-lg bg-indigo-100 text-indigo-600 flex items-center justify-center font-bold text-lg">
                  8F
                </div>
              </div>

              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-3">
                  <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${CATEGORY_COLORS[post.category] || "bg-slate-100 text-slate-700"}`}>
                    {post.category}
                  </span>
                  <span className="text-xs text-slate-400">{post.readTime}</span>
                </div>

                <h2 className="text-lg font-bold text-slate-900 group-hover:text-indigo-600 transition-colors mb-2 line-clamp-2">
                  {post.title}
                </h2>

                <p className="text-sm text-slate-600 leading-relaxed flex-1 line-clamp-3">
                  {post.excerpt}
                </p>

                <div className="mt-4 pt-4 border-t border-slate-100">
                  <span className="text-xs text-slate-400">{post.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
